"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CentsToDisplayStringNoSymbol = exports.CentsToDisplayString = void 0;

const CentsToDisplayString = (amountCents, min = 0, max = 2) => {
  const dollars = amountCents / 100;
  return dollars.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: min,
    maximumFractionDigits: max
  });
};

exports.CentsToDisplayString = CentsToDisplayString;

const CentsToDisplayStringNoSymbol = amountCents => {
  return CentsToDisplayString(amountCents).replace('$', '');
};

exports.CentsToDisplayStringNoSymbol = CentsToDisplayStringNoSymbol;